/**
 * Application header component
 */

import { useAuth } from '../../context/AuthContext';
import Button from '../common/Button';
import './Header.css';

/**
 * Header with branding and user menu
 * @param {Object} props - Component props
 * @param {Function} props.onMenuToggle - Mobile menu toggle handler
 * @returns {React.ReactElement} Header element
 */
export default function Header({ onMenuToggle }) {
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <header className="header">
      <div className="header__left">
        <button
          type="button"
          className="header__menu-btn"
          onClick={onMenuToggle}
          aria-label="Toggle menu"
        >
          <span className="header__menu-icon">
            <span />
            <span />
            <span />
          </span>
        </button>
        <div className="header__brand">
          <img src="/favicon.svg" alt="Logo" className="header__logo" />
          <h1 className="header__title">My Whiskey Collection</h1>
        </div>
      </div>

      <div className="header__right">
        <div className="header__user">
          <span
            className="header__user-email"
            title={user?.user_metadata?.display_name ? user.email : undefined}
          >
            {user?.user_metadata?.display_name || user?.email}
          </span>
          <Button variant="ghost" size="sm" onClick={handleSignOut}>
            Sign Out
          </Button>
        </div>
      </div>
    </header>
  );
}
